/**
 * Official Instagram brand mark — gradient tile + white camera glyph.
 * Matches the WhatsApp mark in size and shape for visual consistency.
 */
export default function InstagramMark({ size = 44 }) {
  return (
    <div
      className="relative inline-flex items-center justify-center rounded-xl overflow-hidden"
      style={{
        width: size,
        height: size,
        background:
          "radial-gradient(circle at 30% 110%, #FFDD55 0%, #FF543E 35%, #C837AB 60%, #5851DB 85%, #515BD4 100%)",
        boxShadow: "0 10px 26px -10px rgba(193, 53, 132, 0.45)",
      }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        width={size * 0.55}
        height={size * 0.55}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="5"
          stroke="#FFFFFF"
          strokeWidth="2"
        />
        <circle cx="12" cy="12" r="4" stroke="#FFFFFF" strokeWidth="2" />
        <circle cx="17.2" cy="6.8" r="1.2" fill="#FFFFFF" />
      </svg>
    </div>
  );
}
